import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { ResumesService, UpdateResumeDataDto } from '@generated/front';
import { meState } from '../../plugins/ridge';

export function useMyResume() {
  const me = meState.useValue();
  return useQuery({
    queryKey: ['resumes', 'me'],
    queryFn: () => ResumesService.resumeControllerResume(),
    enabled: !!me,
  });
}

export const useUpdateResumeMutation = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (requestBody: Record<string, unknown>) =>
      ResumesService.resumeControllerUpdateResume({
        requestBody: requestBody as UpdateResumeDataDto,
      }),
    onSuccess: () => {
      onSuccess && onSuccess();
      toast.success('이력서 저장이 완료되었습니다.');
      queryClient.invalidateQueries({ queryKey: ['resumes'] });
    },
    onError: () => {
      toast.error('이력서 저장에 실패하였습니다.');
    },
  });
};
